function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectGoodsVue from './SelectGoods.vue';
import ButtonUploadExcel from '@/components/ButtonUploadExcel';
import { handleTypeEnum, handleStatusEnum, batchGoodsTypeEnum } from '../../../../enum';
import * as manangeApi from '../../api';
import * as storeApi from '@/api/store';
export default {
  name: 'BatchManage',
  components: {
    SelectGoodsVue: SelectGoodsVue,
    ButtonUploadExcel: ButtonUploadExcel
  },
  data: function data() {
    return {
      dialogVisible: false,
      handleTypeEnum: handleTypeEnum,
      handleStatusEnum: handleStatusEnum,
      batchGoodsTypeEnum: batchGoodsTypeEnum,
      merchantEnum: [],
      //客户列表
      rules: {
        title: [{
          required: true,
          message: '请输入操作简述',
          trigger: 'blur'
        }]
      },
      tableData: {
        list: []
      },
      form: {
        isExcel: 1
      },
      id: null,
      excelData: [],
      hasConfirm: null
    };
  },
  created: function created() {
    this.getCustomers();
  },
  methods: {
    open: function open(id) {
      if (id) {
        this.id = id;
        this.getInfo(id);
      }
      this.hasConfirm = null;
      this.dialogVisible = true;
    },
    close: function close() {
      this.id = null;
      this.form = {
        isExcel: 1
      };
      this.tableData.list = [];
      this.dialogVisible = false;
    },
    getCustomers: function getCustomers() {
      var _this = this;
      manangeApi.getActiveCustomersApi().then(function (res) {
        _this.merchantEnum = res || [];
      });
    },
    deleteRecord: function deleteRecord(index) {
      this.tableData.list.splice(index, 1);
    },
    addGoods: function addGoods() {
      if (this.form.productType) {
        this.$refs.selectGoodsVueRef.open(this.form.productType);
      } else {
        this.$message.warning('请选择商品类型');
      }
    },
    updateTableDate: function updateTableDate(data) {
      var _this2 = this;
      var ids = this.tableData.list.map(function (j) {
        return j.id;
      });
      data.forEach(function (item) {
        var j = _objectSpread(_objectSpread({}, item), {}, {
          cost: item.supplyPrice || 0,
          supplyPrice: 0,
          distributionPrice: item.defaultPrice || 0
        });
        if (!ids.includes(j.id)) {
          _this2.tableData.list.unshift(j);
        }
      });
    },
    getInfo: function () {
      var _getInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return manangeApi.infoApi({
                id: id
              });
            case 1:
              res = _context.v;
              this.form = res;
              this.form.customerIds = res.customerIds.map(function (j) {
                return Number(j);
              });
              if (res.isExcel) {
                this.excelData = res.productList;
              } else {
                this.tableData.list = res.productList;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getInfo(_x) {
        return _getInfo.apply(this, arguments);
      }
      return getInfo;
    }(),
    submit: function submit() {
      var _this3 = this;
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
          var params;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (valid) {
                  params = _objectSpread(_objectSpread({}, _this3.form), {}, {
                    productList: _this3.form.isExcel ? _this3.excelData : _this3.tableData.list
                  });
                  manangeApi[_this3.id ? 'updateApi' : 'saveApi'](params, _this3.hasConfirm ? {
                    hasConfirm: _this3.hasConfirm
                  } : {}).then(function (res) {
                    _this3.$message.success('操作成功！');
                    _this3.$emit('refresh');
                    _this3.close();
                    _this3.hasConfirm = null;
                  }).catch(function (err) {
                    var _ref2 = err && err.data || {},
                      code = _ref2.code,
                      msg = _ref2.msg;
                    if (code == 601 && !_this3.hasConfirm) {
                      storeApi.checkComfirm(msg).then(function (res) {
                        _this3.hasConfirm = res && res.hasConfirm;
                        _this3.submit();
                      });
                    }
                  });
                }
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    request: function () {
      var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(api, params, mes) {
        var _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return api(params);
            case 1:
              this.$message.success(mes);
              this.$emit('refresh');
              this.close();
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t = _context3.v;
              this.$message.error(_t.message);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function request(_x3, _x4, _x5) {
        return _request.apply(this, arguments);
      }
      return request;
    }(),
    // 上传文件
    onSuccess: function onSuccess(excelData) {
      var results = excelData.results;
      var arr = [];
      results.forEach(function (item, index) {
        if (index !== 0) {
          var values = Object.values(item);
          arr.push({
            id: values[0],
            cost: values[1],
            defaultPrice: values[2],
            distributionPrice: values[3],
            supplyPrice: values[4]
          });
        }
      });
      this.excelData = arr;
      this.$message.success('上传成功');
    },
    handleIsExcel: function handleIsExcel() {
      this.excelData = [];
      this.tableData.list = [];
    },
    // 下载模板
    downloadTemplate: function () {
      var _downloadTemplate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.$util.downloadTemplate('importGoodsBatch.xlsx');
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function downloadTemplate() {
        return _downloadTemplate.apply(this, arguments);
      }
      return downloadTemplate;
    }(),
    changeTime: function changeTime(value) {
      if (value === 1) {
        this.$set(this.form, 'exeTime', '');
      }
    }
  }
};